import { BACKEND_URL } from "../../../../../constants/env";
import { ReactNode } from "react";
import { Image } from "@mantine/core";
import { IconCreditCard } from "@tabler/icons";
import { AppointmentPaymentRequest } from "../../../../config/store/bookingStore";
import { Payment } from "../../../../../constants/model/models";

export interface PaymentMethod {
  name: string;
  icon: ReactNode;
  translate?: boolean;
}

export function usePayment() {
  async function retryPayment(
    form: AppointmentPaymentRequest,
    jwt: string
  ): Promise<Payment> {
    const response = await fetch(`${BACKEND_URL}/user/payments/itp`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        accessToken: jwt,
      },
      body: JSON.stringify(form),
    });

    return await response.json();
  }
  async function sendCCPaymentStatus(
    requestId: string,
    jwt: string,
    status: "PAID" | "FAILED"
  ) {
    const response = await fetch(
      `${BACKEND_URL}/user/payments/itp/cc/confirm?requestId=${requestId}&status=${status}`,
      {
        headers: {
          "Content-type": "application/json",
          accessToken: jwt,
        },
      }
    );

    return response.status;
  }

  const paymentOptions: PaymentMethod[] = [
    {
      name: "Multibanco",
      icon: (
        <Image
          src="/img/multibanco.svg"
          alt="Multibanco"
          width="4rem"
          height="3rem"
        />
      ),
    },
    {
      name: "MB WAY",
      icon: <Image src="/img/mbway.svg" alt="MB WAY" height="3.5rem" />,
    },
    // {
    //   name: "payment.credit-card",
    //   translate: true,
    //   icon: <IconCreditCard size="3rem" className="text-gray-800" />,
    // },
  ];

  return {
    sendCCPaymentStatus,
    paymentOptions,
    retryPayment,
  };
}
